(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["locca-hero"] && !Shopify.designMode) return;
  try {
    
  class LoccaHero {
    constructor(root) {
      this.root = root;
      this.video = root.querySelector('.locca-hero__video');
      if (!this.video) return;

      this.video.addEventListener('playing', () => this.root.classList.add('is-playing'));
      this.video.addEventListener('error', () => this.root.classList.remove('is-playing'));

      // Autoplay is refused on some mobile browsers in low-power mode. The promise
      // rejecting is what keeps the fallback colour in place.
      const attempt = this.video.play();
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(() => this.root.classList.remove('is-playing'));
      }

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.video.pause();
      }
    }
  }

  function initLoccaHeroes() {
    document.querySelectorAll('.locca-hero').forEach((el) => new LoccaHero(el));
  }

  document.addEventListener('DOMContentLoaded', initLoccaHeroes);
  document.addEventListener('shopify:section:load', initLoccaHeroes);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
